<template>
  <div class="page-lest-slider">
    <div v-for="(item, index) in routers" :key="index" @click="handleClick(item)" class="txt_center pointer path-box"
      :class="nowpath == item.path || item.path == belong ? 'main_bg cf' : ''">
      <img
        :src="require('@/assets/nav-icon/' + (nowpath == item.path || item.path == belong ? item.selectIconName : item.iconName))"
        alt="" class="icon-path">
      <div>{{ item.name }}</div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import path from '@/utils/pageMainSlider'
import { watch } from "less";
export default {
  data() {
    return {
      path: [],
      nowpath: '',
      belong: ''
    }
  },
  computed: {
    ...mapState(["settings"]),
    ...mapGetters(["routers"]),
  },
  watch: {
    $route(to, from) {
      this.nowpath = to.path;
      this.belong = to.meta ? to.meta.belong : '';
      // if (to) {
      //   this.checkThis = to.meta.belong
      // }
      // this.fetchUserData(to.params.id);
    },
  },
  created() {
    this.nowpath = this.$route.path;
    let p = JSON.parse(JSON.stringify(path));
    this.path = p;
    this.belong = this.$route.meta ? this.$route.meta.belong : '';

  },
  methods: {
    handleClick(item) {
      // console.log(this.nowpath, item.path, 'a--');
      if (this.nowpath == item.path) return;
      this.$router.push(item.path)
      // this.belong = this.$route.meta ? this.$route.meta.belong : '';
      // this.nowpath = item.path;
    }
  }
}

</script>
<style scoped>
.path-box {
  /* margin-bottom: 10px; */
  width: 100%;
  padding: 5px 0;
}

.path-box:last-child {
  margin-bottom: 0;
}

.page-lest-slider {
  position: absolute;
  height: calc(100vh - 76px);
  z-index: 0;
  background: #fff;
  width: 120px;
  /* padding-top: 24px; */
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.icon-path {
  width: 50px;
  display: block;
  margin: 0 auto;
}
</style>